module.exports = __webpack_public_path__ + "static/media/verified-user-icon.39971329.svg";